export const syncType = [
  'Online To Offline',
  'Offline To Online'
];
